import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default gsap;

export {
    gsap,
    ScrollTrigger,
};

export function useGSAP() {
    return {
        gsap,
        ScrollTrigger,
    }
}
